import { Vue, Component, Prop } from 'vue-property-decorator'
import {
	VAvatar,
	VExpansionPanel,
	VExpansionPanelContent,
	VExpansionPanelHeader,
	VFlex,
	VIcon,
	VImg,
	VOverlay,
	VProgressCircular,
	VRow,
	VSpacer
} from 'vuetify/lib'

import './ExpansionPanel.scss'

@Component({})
export class AppExpansionPanel extends Vue {
	@Prop({ type: String, required: false, default: 'Sem título' }) title!: string
	@Prop({ type: String, required: false }) subTitle!: string
	@Prop({ type: String, required: false }) icon!: string
	@Prop({ type: String, required: false }) materialIcon!: string
	@Prop({ type: Boolean, required: false, default: false }) loading!: boolean
	@Prop({ type: Number, required: false }) step!: number

	private render(h: any) {
		return (
			<VExpansionPanel {...{ attrs: this.$attrs }} disabled={this.$attrs.disabled || this.loading} class="atta-expansion-panel mb-4">
				<VOverlay absolute opacity="0" value={this.loading} />
				<VExpansionPanelHeader outlined>
					<VRow>
						<VFlex class="d-flex align-center my-2">
							{this.icon && <VImg src={this.icon} max-width="32" max-height="32" contain class="mr-4 my-2" />}
							{this.materialIcon && (
								<VIcon class="ml-4 mr-6 expansion-panel-header-icon" width="32">
									{this.materialIcon}
								</VIcon>
							)}

							{this.step && (
								<VAvatar rounded color="grey lighten-3 my-2 mr-3" size="32">
									<span class="headline">{this.step}</span>
								</VAvatar>
							)}
							<div>
								{this.$scopedSlots.title ? this.$scopedSlots.title(this.$props) : <span class="app-expansivel-title">{this.title}</span>}
								{this.$scopedSlots.subTitle ? (
									this.$scopedSlots.subTitle(this.$props)
								) : (
									<span class="app-expansivel-subtitle mb-2">{this.subTitle}</span>
								)}
							</div>
						</VFlex>
						<VSpacer />
						{this.$scopedSlots.actions ? <div class="mr-4">{this.$scopedSlots.actions(this.$props)}</div> : ''}
						{this.loading && <VProgressCircular class="ml-4" color="primary" indeterminate />}
					</VRow>
				</VExpansionPanelHeader>
				<VExpansionPanelContent eager>{this.$scopedSlots.default}</VExpansionPanelContent>
			</VExpansionPanel>
		)
	}
}

export default AppExpansionPanel
